<template>
    <div id="footer">
        <div>
            <div>
                <ul class="footer_list">
                    <li>PP-NUB-ES-1094-1 07-2024</li>
                    <li> <a href="https://www.bayer.com/es-es/espana/espana-condiciones-generales-de-uso" target="_blank">Condiciones de uso</a></li>
                    <li> <router-link to="/politica-de-privacidad">Política de privacidad</router-link></li>
                    <li> <a href="https://www.bayer.com/es/es/espana-pie-de-imprenta" target="_blank">Pie de imprenta</a></li>
                    <li> <a href="https://www.bayer.com/es-es/espana/contacto" target="_blank">Contacto</a></li>
                    <li> <a href="https://www.bayer.com/es-es/espana/contacto/farmacovigilancia-y-calidad" target="_blank">Farmacovigilancia</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "FooterMenu",
    data() {
        return {
            loading: true,
        };
    },
    computed: {
    },

    methods: {


    },
    created() {
    },
};
</script>

<style scoped>
#footer {
    padding-top: 10px;
    color: #c1c1c1;
    font-weight: 400;
    text-transform: uppercase;
    font-size: 14px;
    text-align: center;
}

.footer_list {
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    gap: 10px;
    justify-content: center;
    font-size: 14px;
}

.footer_list li {
    font-size: 14px;
}

.footer_list a {
    text-decoration: none;
    color: inherit;
    font-size: 14px;
}

@media screen and (max-width: 768px) {
    #footer {
        padding: 20px
    }

    .footer_list {
        flex-direction: column;
        margin-bottom: 0;
    }
}
</style>
